<template>
	<div 
		:class="stepperClass"
		>
   		<template	
   			v-for="step in stepper.steps"
   			:key="step.index"
   			>
   			<!-- <pre>{{ stepper.steps_progress[step.index]}}</pre> -->
	   		<!-- {%  set progress = stepper.steps_progress[loop.index] %} -->
	        <div 
	        	:class="getStepperClass(step)"
	        	:data-clickable="step.clickable_el ? 'true' : 'false'" 
	        	:data-clickable-url="step.clickable_el.url"
	            :data-actionable="step.status_actions_rendered || step.clickable_el ? 'yes' : 'no'"
	        >
	            <div class="timeline-item-content">
	            	<!-- {# {{ step_index }}::{{ stepper.current_step_index }} #} -->
	                <h6 class="top-title">{{ step.top_title }}</h6>
	                <h4 class="body-big">{{ step.title }}</h4>
	                
	                <div class="two-lines-wrap description">{{ step.description }}</div>
	                
	                <div 
	                	v-if="dtPost.progress_bar"
	                	class="progress-bar-wrap"
	                	>
			            <div class="progress-bar">
			                <span 
			                	class="progress"
			                	:style="`width:${stepper.steps_progress[step.index]}%`"
			                	></span>
			            </div>
			        </div>
					<StepButtonsComponent 
						:step="step"
						:linkTarget="stepper.links_target"
						:stepsMode="stepper.post.steps_mode"
						/>
	            </div>
	        </div>
    	</template>
	</div><!--/.timeline-->
</template>


<script>
import StepButtonsComponent from '@vueapp/components/steppers/StepButtonsComponent.vue'

export default {
	name: 'TopStepperComponent',
	components: {
		StepButtonsComponent,
	},
	props: {
		stepper: {
			type: Object,
			default: {},
			required: true
		}
	},
	data() {
		return {

		}
	},
	methods: {
		getStepperClass( step ) {
			const index = step.index,
				active = step.active,
				steps_mode = this.stepper.post.steps_mode,
				current_step_index = this.stepper.current_step_index,
				inactiveClass = ( steps_mode != 'relaxed' && ! active ) ? 'inactive' : '',
				currentClass = index == current_step_index ? 'current' : ''
			return `timeline-item  ${ inactiveClass } ${ currentClass }`
		}
	},
	computed: {
		stepperClass() {
			return `timeline steps-mode--${this.stepper.post.steps_mode} ${this.stepper.post.progress_bar ? '' : 'no-progress-bar'}`
		},
		dtPost() {
			return this.stepper.post
		}	
	}
}
</script>